var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckFilled = function SvgCheckFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M7 1.664a5.843 5.843 0 0 0-5.833 5.833A5.843 5.843 0 0 0 7 13.331a5.843 5.843 0 0 0 5.833-5.834A5.843 5.843 0 0 0 7 1.664m2.788 4.492L6.481 9.463a.437.437 0 0 1-.619 0l-1.65-1.65a.44.44 0 0 1 0-.619.44.44 0 0 1 .618 0l1.342 1.342L9.17 5.537a.44.44 0 0 1 .618 0 .44.44 0 0 1 0 .619"
  })));
};
export default SvgCheckFilled;